<section *ngIf="showPlayers" class="team qize-section qize-section question-list">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-12 quiz-main-body ">
                <div class="content-main-body">
                    <div class="container-fluid p-p-0">
                        <div class="col-md-12 player-card-body">
                            <div class="d-flex">
                                <!-- <div class="col-lg-6">
                                    <div class="tems-image">
                                        <i class='bx bxs-check-circle'></i>
                                        <div class="team-1">
                                            <img src="assets/img/players/Leander-Paes-3.jpg" alt="">
                                            <div class="name">
                                                <h4 class="title">
                                                    {{contestDetails.player1Name}}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div *ngFor="let player of playersData" class="col-lg-6">
                                    <div (click)="onClickPlayer(player)" class="tems-image">
                                        <!-- <i *ngIf="player.selected" class='pi pi-check'></i> -->
                                        <i *ngIf="player.selected" class='bx bxs-check-circle' style="opacity: 1;"></i>
                                        <div class="team-2">
                                            <img src="{{player.playerImage}}" alt="">
                                            <div class="name">
                                                <h4 class="title">
                                                    {{player.name}}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showSelectedPlayerError" class="error-msg">
                            <span>Please select player.</span>
                        </div>
                        <div class="footer-buttons-section">
                            <button name="next" class="btn btn-success w-auto m-auto"
                                (click)="onClickPlayerNext()">Let's Play</button>
                        </div>
                    </div> <!-- End of col-sm-12 -->
                </div>
            </div> <!-- End of row -->
        </div> <!-- ENd of container fluid -->
    </div>
</section>
<section *ngIf="showQuestions" class="team qize-section question-list">
<p-toast key="toastmsg" position="top-right"></p-toast>

    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-12 quiz-main-body">


                <div class="content-main-body" style="flex-direction: column;margin-top: 0px !important;">
                    <div class="top-header-section">
                        <a (click)="naviagetToContestList()" class="backbtn">
                            <span class="arrow"><img src="../../../../assets/img/contests/back.svg" alt=""></span> Back
                        </a>
                        <div class="top-header-section-main">
                            <h2 class="h2 text-center">{{ contestDetails?.tournamentName }} ({{
                                contestDetails?.tournamentCategoryName }})</h2>
                            <h3 style="font-size: 14px;text-align: center;">
                                <span class="icon">
                                    <img src="../../../../assets/img/contests/whitedate.svg" alt="">
                                </span> {{contestDetails?.matchDate|date:'MMMM d, y, h:mm a'}}
                            </h3>
                            <h3 class="timer-section-heading text-center">
                                <span class="icon mr-2">
                                    <img src="../../../../assets/img/contests/whiteclock.svg" alt="">
                                </span>
                                <span>{{contestDetails['displayTime']}}</span>
                                <span
                                    *ngIf="contestDetails['displayTime'] === 'Match Started' && contestDetails['matchDateTimeUpdated']">
                                    Match Delayed
                                </span>
                            </h3>
                        </div>
                    </div>
                    <div class="container-fluid player-details-div-top">
                        <div class="row m-0">

                            <div class="d-flex top-images-div">
                                <div class="col-sm-4 palyer-image">
                                    <div class="image">
                                        <img [src]="contestDetails?.player1Image" alt="Image not available">
                                    </div>
                                    <!-- <p class="text-center mt-2 fw-bold">{{ contestPlayerName(contestDetails?.player1Name) }}</p> -->
                                </div>
                                <div class="col-sm-4 d-flex justify-content-center align-items-end">
                                    <h4 class="h4 vs">VS</h4>
                                </div>
                                <div class="col-sm-4  palyer-image">
                                    <div class="image">
                                        <img [src]="contestDetails?.player2Image" alt="Image not available">
                                    </div>
                                    <!-- <p class="text-center mt-2 fw-bold">{{ contestPlayerName(contestDetails?.player2Name) }}</p> -->
                                </div>
                            </div>
                            <div class="player-name">
                                <div class="col-sm-4 palyer-image">
                                    <p class="text-center mt-2 fw-bold">{{
                                        contestPlayerName(contestDetails?.player1Name) }}</p>
                                </div>
                                <div class="col-sm-4 d-flex justify-content-center align-items-center">

                                </div>
                                <div class="col-sm-4  palyer-image">
                                    <p class="text-center mt-2 fw-bold">{{
                                        contestPlayerName(contestDetails?.player2Name) }}</p>
                                </div>
                            </div>
                            <div class="col-sm-12 d-flex justify-content-center align-items-center mt-3 p-pl-5 p-pr-5">
                                <ul class="player-points-scorelist mb-0">
                                    <li>Choose 1 option from one player</li>
                                    <li> ⁠Choose 2 options for the other player</li>
                                    <li>Total points will be calculated from the 3 selected options</li>
                                </ul>
                            </div>
                            <div class="note2">
                                <p class="text">To change your selection, please deselect the current option and then
                                    select the desired option</p>
                            </div>
                            <div class="col-sm-12">
                                <div class="Select-quationn-list">
                                    <ul>

                                        <li *ngFor="let question of questionsList"
                                            [ngClass]="question.disable == true ? 'disable-list' : ''">
                                            <div class="QA-list">
                                                <div class="palyer-1-checkbox">
                                                    <p-checkbox binary="true" [disabled]="question.disable1" [(ngModel)]="question.selected1"
                                                        (onChange)="onQuestionSelect(question,$event,'player1')"></p-checkbox>
                                                </div>
                                                <div class="Question-div text d-flex justify-content-center">
                                                    <span>{{ question.question }} <span class="points">({{
                                                            question.points }} pts)</span></span>
                                                </div>
                                                <div class="palyer-2-checkbox">
                                                    <p-checkbox binary="true" [disabled]="question.disable2" [(ngModel)]="question.selected2"
                                                        (onChange)="onQuestionSelect(question,$event,'player2')"></p-checkbox>
                                                </div>
                                            </div>

                                        </li>
                                        <!-- <li>
                                            <label class="layout" for="check2">
                                                <input type="checkbox" class="check" name="check2" id="check2">
                                                <div class="text">
                                                    <span>Play 0n Number of Games </span><span>6 TPL Pts per
                                                        Game Won</span>
                                                </div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="layout" for="check3">
                                                <input type="checkbox" class="check" name="check3" id="check3">
                                                <div class="text">
                                                    <span>Number of Sets won </span><span>50 TPL Pts per
                                                        Set</span>
                                                </div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="layout" for="check4">
                                                <input type="checkbox" class="check" name="check4" id="check4">
                                                <div class="text">
                                                    <span>Number of Aces </span><span>10 TPL Pts per Ace.
                                                        Set</span>
                                                </div>
                                            </label>
                                        </li>
                                        <li>
                                            <label class="layout" for="check5">
                                                <input type="checkbox" class="check" name="check5" id="check5">
                                                <div class="text">
                                                    <span>Break Points Won </span><span>20 TPL Pts per Break
                                                        Points Won
                                                        Set</span>
                                                </div>
                                            </label>
                                        </li> -->
                                    </ul>
                                    <div class="error-msg mt-4" *ngIf="showQuestionsError">
                                        Please select one option from either player 1 or player 2, and two options from
                                        either player 1 or player 2
                                    </div>
                                    <div class="error-msg fs-6 mt-4" *ngIf="minimumCoinsForContestJoinError">
                                        You don't have enough coins to join the contest.
                                    </div>
                                </div>
                            </div> <!-- End of col-sm-12 -->
                            <div class="footer-buttons-section-div">
                                <button (click)="onClickQuestionSubmit()" name="next"
                                    class="btn btn-success w-auto m-auto">Let's Play</button>
                            </div>
                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>


    <p-dialog id="add-cash-new-popup" header="" [(visible)]="doOpenContestJoinPaymentPopup"
        [breakpoints]="{ '960px': '500px', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }" [modal]="true"
        [draggable]="false" [resizable]="false" (onHide)="navigateToContestPaymentPage()">
         
        <div class="popup-body">
            <div class="popup-head">
                <div class="list-of-box d-flex">
                    <div class="box">
                        <p>TPL Cash Available</p>
                        <h5><span class="rupee-icon">₹</span>{{ totalAvailableCash }}</h5>
                    </div>
                    <div class="box">
                        <p>Contest Cash Available</p>
                        <h5><span class="rupee-icon">₹</span>{{ totalAvailableContestCash }}</h5>
                    </div> 
                </div>
            </div>  
            <div class="popup-mai-div-body">
                <div class="title-main-div">
                    <h5>Confirmation</h5>
                </div>
                <div class="table-main-div">
                    <table class="table table-borderless">
                        <tbody>
                            <tr>
                                <td>Entry</td>
                                <td><span class="rupee-icon">₹</span>{{entryFee}}</td>
                            </tr>
                            <tr>
                                <th>To Pay <img src="../../../assets/img/home/m10.svg" alt=""  (click)="toggleOverlay($event, overlay)"  [pTooltip]="contestJoinAmountCalculation" >
                                    <p-overlayPanel #overlay appendTo="body" [baseZIndex]="99999999" [ngStyle]="{'z-index': '99999999'}">
                                        <div [innerHTML]="contestJoinAmountCalculation"></div>
                                      </p-overlayPanel>
                                      </th>
                                <th><span class="rupee-icon">₹</span>{{entryFee}}</th>
                            </tr>
                        </tbody>
                    </table>
                    <div class="form-check p-0 d-flex align-items-start mb-2" >
                        <p-checkbox binary="true" [(ngModel)]="isTermsAndConditionsSelected"
                            (onChange)="onTermsAndConditionsSelect($event)"></p-checkbox>
                        <label class="form-check-label" for="defaultCheck1">
                            i agree with standard  <a href="/termsandcondition#TPLcontest">Terms and conditions</a>  
                        </label> 
                    </div>
                </div>
                
       

                <div class="col-xl-12 d-lg-flex justify-content-xl-end">
                    <div *ngIf="minimumContestJoinAmountError"
                           class="p-error mx-2">
                           Minimum amount for joining contest entry fee is <i class='bx bx-rupee'></i>{{entryFee}}.
                    </div>
                </div>
                <div class="col-xl-12 d-lg-flex justify-content-xl-end text-center">
                    <div class="footer-buttons-section-div">
                        <button type="button" (click)="joinNowContestCashContest()" class="btn btn-success w-auto m-auto" pButton>Join Now</button>
                    </div>
                </div>
            </div>
        </div> 
    </p-dialog>
</section>
<section *ngIf="showThankYou" class="team qize-section thankyou">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-12 quiz-main-body">
                <div class="content">
                    <div class="container-fluid">
                        <div class="col-md-12 align-items-center thankYoudiv">
                            <div class="jumbotron text-center">
                                <div class="Thank-you-gif">
                                    <img src="assets/img/players/output-onlinegiftools.gif" alt="">
                                </div>
                                <h1 class="display-6 mb-0 mt-6">All the Best!</h1>
                                <p class="lead"><strong>Your Contest Submissions Have Been Completed </strong>
                                </p>
                                <hr>
                                <p>
                                    Look At Your Score On The Leaderboard.
                                </p>
                                <p class="lead">
                                    <a class="" href="leader-board-final.html" role="button"></a>
                                    <button pButton class="btn btn-primary btn-lg"
                                        (click)="onClickViewLeaderBoard(contestId);">View
                                        Leaderboard</button>
                                    <button pButton class="btn btn-primary btn-lg" (click)="onClickViewContest();">My
                                        Contest</button>

                                </p>

                            </div>
                        </div>
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>
</section>